import React, { useEffect, useState } from 'react';
import { WideDown, WideUp } from 'src/utils/breakpoints';
import { TabDetails } from './TabDetails';
import { TabNav } from './TabNav';

export const OurProcesses = ({ activeProcess }) => {
  const [activeStepIndex, setActiveStepIndex] = useState(0);

  const Background = activeProcess.styles.background;

  useEffect(() => {
    setActiveStepIndex(0);
  }, [activeProcess]);

  return (
    <div className="processes-outer">
      <WideUp>
        {activeProcess.steps.map((step, i) => (
          <TabNav
            key={step._key}
            processStyles={activeProcess.styles}
            onHover={() => setActiveStepIndex(i)}
            title={step.title}
            isActive={i === activeStepIndex}
          />
        ))}
      </WideUp>

      <WideUp>
        <Background alt="Slider background" className="processes-illustration" />
      </WideUp>

      <WideUp>
        {activeProcess.steps.map(
          (step, i) =>
            activeStepIndex === i && (
              <TabDetails
                processStyles={activeProcess.styles}
                key={step._key}
                data={{
                  title: step.title,
                  description: step.body,
                }}
              />
            )
        )}
      </WideUp>

      <WideDown>
        {activeProcess.steps.map((step) => (
          <TabDetails
            processStyles={activeProcess.styles}
            key={step._key}
            data={{
              title: step.title,
              description: step.body,
            }}
          />
        ))}
      </WideDown>
    </div>
  );
};
